import React from 'react';

import { configUI } from 'config';
import { useInfiniteScrollPaging } from 'modules/shared/hooks';
import { ColumnListContainer, ColumnOptions } from 'modules/shared-ui/components';

import { LightProduct } from '../../../../../models';
import { ProductThumbnail } from '../../../product-thumbnail';

import { ProductCollectionProps } from './product-collection-type';

import styles from './product-collection-component.module.css';

const getPagination = (options: ColumnOptions): number => {
    const screenWidth = window.innerWidth;
    if (screenWidth <= configUI.responsive.mobile.maxWidth) {
        return options.mobile[0];
    }
    if (screenWidth <= configUI.responsive.tablet.maxWidth) {
        return options.tablet[0];
    }
    return options.computer[0];
};

export const ProductCollection: React.FC<ProductCollectionProps> = React.memo(
    ({ products }: ProductCollectionProps) => {
        if (products && products.length > 0) {
            const options = {
                mobile: [2],
                tablet: [4],
                computer: [6],
            };
            const [listItems] = useInfiniteScrollPaging(products, getPagination(options));
            return (
                <React.Fragment>
                    <div className={styles.container}>
                        <ColumnListContainer
                            options={options}
                            hideOptions
                            items={listItems}
                            itemRenderer={(product: LightProduct) => {
                                return (
                                    <div className={styles.ficheProductContainer} key={product.id}>
                                        <ProductThumbnail product={product} />
                                    </div>
                                );
                            }}
                        />
                    </div>
                </React.Fragment>
            );
        }
        return <div className={styles.container}>Aucun produit ne correspond à ces critères</div>;
    },
);
